import { render, staticRenderFns } from "./yc-profit-page.vue?vue&type=template&id=799f2116&scoped=true&"
import script from "./yc-profit-page.vue?vue&type=script&lang=js&"
export * from "./yc-profit-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f2116",
  null
  
)

export default component.exports